import { ChartBarIcon, type V2SidebarNavItem } from "@stacklet/ui";
import { graphql, useFragment } from "react-relay";

import { useConfig } from "app/contexts";

import type { useEnabledDashboards_query$key } from "./__generated__/useEnabledDashboards_query.graphql";

type EnabledDashboard = {
  label: string;
  Icon?: V2SidebarNavItem["Icon"];
  id: string;
  key: string;
  target: string;
  activePaths?: string[];
};

export function useEnabledDashboards(queryRef: useEnabledDashboards_query$key) {
  const config = useConfig();

  const data = useFragment(
    graphql`
      fragment useEnabledDashboards_query on Query
      @argumentDefinitions(filterElement: { type: "FilterElementInput" }) {
        dashboards(filterElement: $filterElement) {
          edges {
            node {
              key
              title
            }
          }
        }
      }
    `,
    queryRef,
  );

  const hiddenDashboardKeys = config?.hidden_dashboard_keys || [];

  const enabledDashboards: EnabledDashboard[] = [];
  const cisActivePaths: string[] = [];
  let cisAdded = false;

  for (const edge of data.dashboards.edges ?? []) {
    const { key, title } = edge.node;
    if (hiddenDashboardKeys.includes(key)) continue;

    if (key.startsWith("cis-")) {
      cisActivePaths.push(`/dashboards/${key}`);
      if (!cisAdded) {
        enabledDashboards.push({
          label: "CIS",
          Icon: ChartBarIcon,
          id: "cis",
          key: "cis",
          target: "/dashboards/cis",
          activePaths: cisActivePaths,
        });
        cisAdded = true;
      }
    } else {
      enabledDashboards.push({
        label: title,
        Icon: ChartBarIcon,
        id: title.toLowerCase(),
        key,
        target: `/dashboards/${key}`,
      });
    }
  }

  return enabledDashboards;
}
